export const MenuIdStatusPageManage = 'STATUS_PAGE_MANAGE' as const;
